import { Link } from 'react-router-dom';
import MovieCard from './MovieCard';
import type { MovieItem } from '@/mocks/movies';

interface FeaturedSectionProps {
  title: string;
  subtitle?: string;
  movies: MovieItem[];
  categoryKey: string;
}

export default function FeaturedSection({ title, subtitle, movies, categoryKey }: FeaturedSectionProps) {
  const displayMovies = movies.slice(0, 8);

  return (
    <section className="w-full px-4 md:px-6 py-6 md:py-8">
      <div className="flex items-center justify-between mb-5">
        <div>
          <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-900">
            {title}
          </h2>
          {subtitle && (
            <p className="text-sm text-foreground-500 mt-0.5">{subtitle}</p>
          )}
        </div>
        <Link
          to={`/category/${categoryKey}`}
          className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
        >
          查看全部
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 gap-4 md:gap-5">
        {displayMovies.map((movie) => (
          <MovieCard key={movie.id} movie={movie} />
        ))}
      </div>
    </section>
  );
}